import { toast } from "react-toastify";
import httpService from "./httpService";
import config from '../config/apiConfig';


export async function GetDatosConfiguracion(){
  try{
      
      let urlDatosConfiguracion = config.api_url+'configuracion/';
      const token = localStorage.getItem("token");
      const respuesta = await httpService.get(urlDatosConfiguracion, {
      headers: {
        'token': token // El formato que vimos que funciona en tu KDS
      }
      });
      console.log(urlDatosConfiguracion, respuesta);
      return respuesta.data;
    }
    catch(error){
      toast.error("Se ha provocado un error al desplegar los datos de configuración!")
    }
}

const getHeaders = () => ({
    'Content-Type': 'application/json',
    'token': localStorage.getItem('token')
});

// 🚩 Resiliencia de configuración: el endpoint de parámetros respondió 500
// una vez de forma intermitente ("[Errno 22] Invalid argument"). Un fallo
// aislado no debe dejar los flags en false (eso hacía que un delivery pagado
// se guardara como PENDIENTE_PAGO). Reintentamos y, si aun así falla,
// devolvemos la última copia buena guardada en el navegador.
const CACHE_AJUSTES_KEY = 'komity_ajustes_parametros_cache';

const esperar = (ms) => new Promise(resolve => setTimeout(resolve, ms));

export const getAjustesParametrosCache = () => {
    try {
        const raw = localStorage.getItem(CACHE_AJUSTES_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch (e) {
        return null;
    }
};

const guardarAjustesCache = (ajustes) => {
    try {
        localStorage.setItem(CACHE_AJUSTES_KEY, JSON.stringify(ajustes || {}));
    } catch (e) {
        // localStorage lleno o deshabilitado: no es crítico.
    }
};

const fetchConReintentos = async (url, opciones, reintentos = 2, esperaMs = 350) => {
    let ultimoError = null;

    for (let intento = 0; intento < reintentos; intento++) {
        try {
            const response = await fetch(url, opciones);

            if (!response.ok) {
                throw new Error(`Error ${response.status}: No se pudo obtener la configuración`);
            }

            return await response.json();
        } catch (e) {
            ultimoError = e;
            if (intento < reintentos - 1) await esperar(esperaMs * (intento + 1));
        }
    }

    throw ultimoError;
};


export const obtenerSectores = async () => {
    const res = await fetch(`${config.api_url}/api/sectores-despacho`, { headers: getHeaders() });
    return await res.json();
};

export const guardarSector = async (sector) => {

    const isEdit = sector.id ? true : false;
    const url = isEdit ? `${config.api_url}/api/sectores-despacho/${sector.id}` : `${config.api_url}/api/sectores-despacho`;
    const method = isEdit ? 'PUT' : 'POST';

    console.log("url", url)
    const res = await fetch(url, {
        method,
        headers: getHeaders(),
        body: JSON.stringify(sector)
    });
    return await res.json();
};

export const eliminarSector = async (id) => {
    const res = await fetch(`${config.api_url}/api/sectores-despacho/${id}`, {
        method: 'DELETE',
        headers: getHeaders()
    });
    return await res.json();
};

// --- Métodos de pago personalizados (TPV, botón "Otros") ---
export const obtenerMetodosPagoPersonalizados = async () => {
    const res = await fetch(`${config.api_url}/api/metodos-pago-personalizados`, { headers: getHeaders() });
    return await res.json();
};

export const crearMetodoPagoPersonalizado = async (nombre) => {
    const res = await fetch(`${config.api_url}/api/metodos-pago-personalizados`, {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify({ nombre })
    });
    return await res.json();
};

export const actualizarMetodoPagoPersonalizado = async (id, cambios) => {
    const res = await fetch(`${config.api_url}/api/metodos-pago-personalizados/${id}`, {
        method: 'PUT',
        headers: getHeaders(),
        body: JSON.stringify(cambios)
    });
    return await res.json();
};

export const eliminarMetodoPagoPersonalizado = async (id) => {
    const res = await fetch(`${config.api_url}/api/metodos-pago-personalizados/${id}`, {
        method: 'DELETE',
        headers: getHeaders()
    });
    return await res.json();
};

// 1. GET: Listar todas las plataformas
// ===========================================
// 2. CRUD PARA PLATAFORMAS EXTERNAS (Rappi, Uber, etc.)
// (El nuevo mantenedor)
// ===========================================

export const obtenerPlataformasExternas = async () => {
    const res = await fetch(`${config.api_url}/api/plataformas-externas`, { headers: getHeaders() });
    return await res.json();
};

export const guardarPlataforma = async (platformData) => {
    const isEdit = platformData.id ? true : false;
    const url = isEdit 
        ? `${config.api_url}/api/plataformas-externas/${platformData.id}` // PUT
        : `${config.api_url}/api/plataformas-externas`; // POST

    const method = isEdit ? 'PUT' : 'POST';
    
    const res = await fetch(url, {
        method,
        headers: getHeaders(),
        body: JSON.stringify(platformData)
    });
    return await res.json();
};

export const eliminarPlataforma = async (id) => {
    const res = await fetch(`${config.api_url}api/plataformas-externas/${id}`, {
        method: 'DELETE',
        headers: getHeaders()
    });
    return await res.json();
};

// configuracion del sistema negocio
export const fetchConfiguracion = async () => {
    try {
        const token = localStorage.getItem('token');
        return await fetchConReintentos(`${config.api_url}/api/configuracion/valores`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'token': token
            }
        });
    } catch (e) {
        console.error("Error en fetchConfiguracion:", e);
        throw e; // <--- ESTO PROPAGA EL ERROR A LA FUNCIÓN LLAMADORA
    }
};

//parametros y flags 
export const fetchConfiguracionParametros = async ({ permitirCache = true } = {}) => {
    const token = localStorage.getItem('token');

    try {
        const data = await fetchConReintentos(`${config.api_url}/api/configuracion/parametros/valores`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'token': token
            }
        });

        if (data && data.ajustes) guardarAjustesCache(data.ajustes);
        return data;
    } catch (e) {
        const cache = permitirCache ? getAjustesParametrosCache() : null;
        if (cache && Object.keys(cache).length > 0) {
            console.warn("Configuración de parámetros no disponible; usando última copia local.", e);
            return { completado: true, ajustes: cache, desde_cache: true };
        }

        console.error("Error en fetchConfiguracionParametros:", e);
        throw e;
    }
};